<template>
  <el-breadcrumb separator="/" separator-icon="el-icon-arrow-right" class="hidden-sm-and-down">
    <el-breadcrumb-item v-for="item in this.$route.matched" :key="item.title">
      <el-icon class="icon" v-if="item.meta.icon"><component :is="item.meta.icon" /></el-icon>
      {{item.meta.title}}
    </el-breadcrumb-item>
  </el-breadcrumb>
</template>

<script>
export default {
  
}
</script>

<style lang="scss" scoped>
.el-breadcrumb {
  margin-left: 10px;
  .el-breadcrumb__inner .icon {
    font-size: 14px;
    margin-right: 5px;
    float: left;
  }
}
</style>